import { notifications } from '@mantine/notifications';
import type { ToastProps } from './toast.model';

const defaultValues = {
  title: 'Berhasil',
  message: 'Menyimpan Data',
};

export const success = (props?: ToastProps) => {
  const { cb, ...others } = props ?? {};
  notifications.show({
    ...defaultValues,
    ...others,
    color: 'success',
  });
  cb?.();
};
